(() => {
  if (window.__akExportLoader) return;
  window.__akExportLoader = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ak-export-format]');
    if (!button) return;
    const root = button.closest('[data-ak-export]');
    if (root.dataset.busy === 'true') return;
    const labels = JSON.parse(root.querySelector('[data-ak-export-labels]').textContent);
    const status = root.querySelector('[data-ak-export-status]');
    root.dataset.busy = 'true';
    root.querySelectorAll('[data-ak-export-format]').forEach(item => { item.disabled = true; });
    status.textContent = labels.starting;
    status.dataset.error = 'false';
    try {
      const module = await import(root.dataset.module);
      await module.downloadCatalog(root, button.dataset.akExportFormat, labels);
    } catch (error) {
      status.textContent = labels.error;
      status.dataset.error = 'true';
    } finally {
      root.dataset.busy = 'false';
      root.querySelectorAll('[data-ak-export-format]').forEach(item => { item.disabled = false; });
    }
  });
})();
